module.exports = __webpack_public_path__ + "img/title-horizontal.4af368e0.png";